/**
Combines classes into a browser-readable string.
@param {string[]} classes - The array of classes.
@returns {string} - The browser-ready string of classes.
*/
const classMap = (...classes: (string | undefined | null)[]): string => {
  return classes
    .filter(Boolean) // remove any falsy values
    .reduce((acc, className) => {
      if (!acc.includes(className)) {
        acc += ` ${className}`;
      }
      return acc;
    }, "")
    .trim();
};

export default classMap;
